<template>
    <v-card class="Calculator" flat>
        <!-- <v-toolbar flat color="deep-purple darken-4" dark>
            <v-toolbar-title>Nouvelle grille de calcul</v-toolbar-title>
            <v-spacer />

            <v-icon
                class="clickable"
                @click.stop="close"
                right
            >mdi-close</v-icon>
        </v-toolbar> -->

        <v-navigation-drawer
            v-model="search.show"
            absolute
            temporary
            right
        >
            <v-card flat>
                <v-card-title>
                    Filtres<v-spacer/>
                    <v-btn
                        title="Appliquer"
                        right
                        small
                        fab
                        icon
                        @click.stop="search.show = false"
                    >
                        <v-icon>mdi-check</v-icon>
                    </v-btn>

                    <v-btn
                        title="Effacer les filtres"
                        right
                        small
                        fab
                        icon
                        @click.stop="initSearchTool"
                    >
                        <v-icon>mdi-cached</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-text-field 
                        v-if="search.tools.indexOf('text') > -1"
                        v-model="search.text" 
                        label="Rechercher" 
                        class="mx-4"
                        prepend-icon="mdi-magnify"
                    />
                    
                    <v-select
                        v-if="search.tools.indexOf('vendor') > -1 && step === 1"
                        v-model="search.vendor"
                        :items="$store.getters['vendors/select']"
                        label="Fournisseur"
                        prepend-icon="mdi-office-building"
                        class="mx-4"
                        clearable
                    />

                    <v-select
                        v-if="Boolean(categories.length) && step === 1"
                        v-model="search.category"
                        :items="categories"
                        label="Catégorie"
                        prepend-icon="mdi-tag-text"
                        class="mx-4"
                        clearable
                    />
                    
                    <div 
                        v-if="step === 1"
                        class="ma-5 d-flex flex-column"
                    >
                        <v-btn 
                            class="monochrome-gradient ma-2"
                            :class="search.color === false ? 'deep-border' : ''"
                            @click="searchColor(false)"
                            dark
                        >Monochrome</v-btn >
                        
                        <v-btn 
                            class="color-gradient ma-2"
                            :class="search.color === true ? 'deep-border' : ''"
                            @click="searchColor(true)"
                            dark
                        >Couleurs</v-btn >
                    </div>
                </v-card-text>
            </v-card>
        </v-navigation-drawer>
        
        <v-card flat>
            <v-speed-dial
                v-model="dial"
                fixed
                bottom
                right
                direction="top"
                transition="slide-y-reverse-transition"
            > 
                <template v-slot:activator>
                    <v-btn
                        v-model="dial"
                        dark
                        color="pink"
                        fab
                    >
                        <v-icon v-if="dial">mdi-close</v-icon>
                        <v-icon v-else>mdi-dots-horizontal</v-icon>
                    </v-btn>
                </template>
            
                <v-btn 
                    fab
                    small
                    color="red darken-1"
                    dark
                    @click="close"
                >
                    <v-icon>mdi-cancel</v-icon>
                </v-btn>
                
                <v-btn
                    v-if="Boolean(trx.mainframe.length)"
                    title="Enregistrer"
                    small
                    color="success"
                    dark
                    fab
                    @click.stop="save"
                >
                    <v-icon dark>mdi-content-save</v-icon>
                </v-btn>
                
                <v-btn
                    title="Filtrer les résultats"
                    small
                    color="deep-purple darken-4"
                    dark
                    fab
                    @click.stop="search.show = true"
                >
                    <v-icon dark>mdi-magnify</v-icon>
                </v-btn>
            </v-speed-dial>
            
            <v-stepper 
                v-model="step" 
                vertical
            >
                
                <v-stepper-step 
                    :complete="step > 1" 
                    step="1"
                    color="deep-purple darken-4"
                    class="clickable"
                    @click.prevent="doStep(1)"
                >Sélectionner l'appareil</v-stepper-step>

                <v-stepper-content step="1">
                    <v-card>  
                        <v-card-text>
                            <v-data-table
                                v-if="Boolean(visibleMainframes.length) && Boolean(headers('mainframes').length) && Boolean(vendors.length)"
                                v-model="trx.mainframe"
                                :items="visibleMainframes"
                                item-key="sku"
                                :headers="headers('mainframes')"
                                :search="search.text"
                                show-select
                                single-select
                                @item-selected="trx.accessories = []"
                                :sort-by="defaultSort"
                                :items-per-page="10"
                            >

                                <template v-slot:item.vendor="{ item }">
                                    <span>{{ getVendorsNameById(item.vendor) }}</span>
                                </template>

                                <template v-slot:item.model="{ item }">
                                    <span>{{ item.model.length > 20 ? `${item.model.substring(0, 20)}...` : item.model }}</span>
                                </template>

                                <template v-slot:item.categories="{ item }">
                                    <span>{{ item.categories.join(', ') }}</span>
                                </template>

                                <template v-slot:item.color="{ item }">
                                    <v-avatar 
                                        size="32"
                                        :class="`${item.color ? 'color-gradient': 'monochrome-gradient'}`"
                                    ></v-avatar>
                                </template>

                                <template v-slot:item.comment="{ item }">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon 
                                                v-if="Boolean(item.comment)" 
                                                color="red"
                                                v-on="on"
                                            >mdi-alert</v-icon>
                                        </template>
                                        <span>{{item.comment}}</span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>

                            <v-expand-transition> 
                                <v-menu offset-y v-if="Boolean(vendor)">
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            color="deep-purple darken-4"
                                            dark
                                            v-on="on"
                                        >Outils du fournisseur</v-btn>
                                    </template>

                                    <v-list>
                                        <v-list-item
                                            v-for="(item, index) in vendor[1].webTools"
                                            :key="`webTool-${index}`"
                                            dense
                                            :href="item.url"
                                            target="_blank"
                                        >
                                            <v-list-item-title>{{ item.link }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-expand-transition>
                        </v-card-text>
                    </v-card>
                </v-stepper-content>

                <v-stepper-step 
                    :complete="step > 2" 
                    step="2"
                    color="deep-purple darken-4"
                    :class="Boolean(trx.mainframe.length) ? 'clickable' : ''"
                    @click.prevent="doStep(2, Boolean(trx.mainframe.length))"
                >Ajouter des accessoires</v-stepper-step>

                <v-stepper-content step="2">
                    <v-card flat>           
                        <v-card-text>                    
                            <v-data-table
                                v-if="Boolean(accessories.length)"
                                :headers="headers('accessories')"
                                :items="accessories"
                                @click:row="addAccessoryToCalc"
                                :search="search.text"
                            />
                        </v-card-text>
                    </v-card>
                </v-stepper-content>
                    
                <v-stepper-step 
                    :complete="step > 3" 
                    step="3"
                    color="deep-purple darken-4"
                    :class="Boolean(trx.mainframe.length) ? 'clickable' : ''"
                    @click.prevent="doStep(3, Boolean(trx.mainframe.length))"
                >Appliquer une escompte du fournisseur</v-stepper-step>

                <v-stepper-content step="3">
                    <v-card>
                        <v-card-text>
                            <v-expand-transition>
                                <v-data-table
                                    v-if="!Boolean(trx.customPromo) && Boolean(promos.length)"
                                    v-model="trx.promo"
                                    show-select
                                    single-select
                                    :headers="headers('promos')"
                                    :items="promos"
                                    :search="search.text"
                                    sort-by="name"
                                />
                            </v-expand-transition>

                            <v-expand-transition>
                                <v-form 
                                    v-if="Boolean(trx.customPromo) && !Boolean(trx.promo.length)" 
                                    @submit.prevent="addCustomPromo"
                                >
                                    <v-text-field
                                        v-model="customPromo.discount"
                                        type="number"
                                        :messages="[`Montant total de la réduction consentie par le fournisseur. Ce 
                                        montant doit inclure toute autre réduction aussi appliquable, s'il y a lieu.`]"
                                    />

                                    <v-text-field
                                        v-model="customPromo.authorizedBy"
                                        :messages="['Autorisé par']"
                                    />
                                    
                                    <v-textarea
                                        v-model="customPromo.details"
                                        :messages="[`Copier l'autorisation écrite ici`]"
                                    />

                                    <v-text-field
                                        v-model="customPromo.date"
                                        :messages="[`Date de l'autorisation écrite`]"
                                        disabled
                                    />

                                    <v-expand-transition>
                                        <div class="d-flex justify-end">
                                            <v-btn 
                                                v-if="allowCustomPromo"
                                                fab
                                                dark
                                                color="success"
                                                type="submit"
                                            >
                                                <v-icon>mdi-check</v-icon>
                                            </v-btn>
                                        </div>
                                    </v-expand-transition>  
                                </v-form>  
                            </v-expand-transition> 

                            <v-alert
                                v-if="allowCustomPromo && Boolean(trx.promo.length)"
                                dismissible
                                type="info"
                                @input="clearPromos"
                            >Une escompte de {{ $p9.parse.money(customPromo.discount) }} autorisée par {{ customPromo.authorizedBy }} est actuellement appliquée.</v-alert>

                            <v-switch
                                v-else
                                v-model="trx.customPromo"
                                :label="`Entente spéciale avec le fournisseur`"
                                @change="initCustomPromo"
                            />
                        </v-card-text>
                    </v-card>
                </v-stepper-content>
                    
                <v-stepper-step 
                    :complete="step > 4" 
                    step="4"
                    color="deep-purple darken-4"
                    :class="Boolean(trx.mainframe.length) ? 'clickable' : ''"
                    @click.prevent="doStep(4, Boolean(trx.mainframe.length))"
                >Déterminer les frais de transport et d'installation</v-stepper-step>
                
                <v-stepper-content step="4">
                    <v-card>
                        <v-card-text>
                            <div class="d-flex">
                                <v-text-field
                                    v-model="trx.installation"
                                    type="number"
                                    :messages="[`Frais d'installation`]"
                                    prepend-icon="mdi-tools"
                                    suffix="$"
                                />

                                <v-spacer />

                                <v-text-field
                                    v-model="trx.transport"
                                    type="number"
                                    :messages="[`Frais de transport`]"
                                    prepend-icon="mdi-truck"
                                    suffix="$"
                                />
                            </div>
                            
                        </v-card-text>
                    </v-card>
                </v-stepper-content>
                    
                <v-stepper-step 
                    :complete="step > 5" 
                    step="5"
                    color="deep-purple darken-4"
                    :class="Boolean(trx.mainframe.length) ? 'clickable' : ''"
                    @click.prevent="doStep(5, Boolean(trx.mainframe.length))"
                >Rachat d'un équipement usagé</v-stepper-step>

                <v-stepper-content step="5">

                    <v-card>
                        <v-card-text>
                            <v-switch
                                v-model="trx.repo"
                                label="Rachat d'équipement"
                            />

                            <v-expand-transition>
                                <v-text-field
                                    v-if="Boolean(trx.repo)"
                                    v-model="repo.value"
                                    type="number"
                                    :messages="[`Crédit à appliquer pour rachat d'équipement`]"
                                    prepend-icon="mdi-cash-minus"
                                    suffix="$"
                                />
                            </v-expand-transition>

                            <v-expand-transition>
                                <div v-if="!Boolean(trx.repo)">
                                    <v-alert type="warning">Aucun équipement à racheter au client</v-alert>
                                </div>
                            </v-expand-transition> 
                        </v-card-text>
                    </v-card>
                </v-stepper-content>
                    
                <v-stepper-step 
                    :complete="step > 6" 
                    step="6"
                    color="deep-purple darken-4"
                    :class="Boolean(trx.mainframe.length) ? 'clickable' : ''"
                    @click.prevent="doStep(6, Boolean(trx.mainframe.length))"
                >Définir les options de financement</v-stepper-step>

                <v-stepper-content step="6">
                    <v-card>
                        <v-card-text>
                            <v-switch
                                v-model="trx.buyout"
                                label="Valeur résiduelle sur financement courant"
                            />

                            <v-expand-transition>
                                <div v-if="Boolean(trx.buyout)">
                                    <v-text-field
                                        v-model="buyout.value"
                                        type="number"
                                        :messages="[`Montant du résiduel sur contrat courant`]"
                                        prepend-icon="mdi-cash-minus"
                                        suffix="$"
                                    />
                                    
                                    <v-text-field
                                        v-model="buyout.vendor"
                                        :messages="[`Fournisseur de crédit actuel`]"
                                        prepend-icon="mdi-bank"
                                    />
                                    
                                    <v-text-field
                                        v-model="buyout.leaseId"
                                        :messages="[`ID du contrat de financement actuel`]"
                                        prepend-icon="mdi-pound"
                                    />
                                </div>
                            </v-expand-transition>

                            <v-expand-transition>
                                <div v-if="!Boolean(trx.buyout)">
                                    <v-alert type="warning">Aucun contrat courant à racheter</v-alert>
                                </div>
                            </v-expand-transition> 

                            <v-switch
                                v-model="trx.lease"
                                label="Financement"
                            />

                            <v-expand-transition>
                                <v-select
                                    v-if="trx.lease"
                                    v-model="lease.vendor"
                                    :items="vendorsSelect"
                                    label="Sélectionner un fournisseur"
                                    prepend-icon="mdi-bank"
                                    clearable
                                />
                            </v-expand-transition> 

                            <v-expand-transition>                                
                                <v-select
                                    v-if="Boolean(lease.vendor)"
                                    v-model="lease.term"
                                    :items="leaseOptionTerms"
                                    label="Terme du contrat (mois)"
                                    prepend-icon="mdi-calendar-month"
                                    clearable
                                />
                            </v-expand-transition> 

                            <v-expand-transition>                                
                                <v-select
                                    v-if="Boolean(lease.term)"
                                    v-model="lease.freq"
                                    :items="leaseTermFrequencies"
                                    label="Fréquence des versements"
                                    prepend-icon="mdi-timer-sand"
                                    clearable
                                />
                            </v-expand-transition>

                            <v-expand-transition>                                
                                <v-select
                                    v-if="Boolean(lease.freq)"
                                    v-model="lease.buyout"
                                    :items="leaseFrequencyBuyouts"
                                    label="Valeur résiduelle du contrat"
                                    prepend-icon="mdi-chart-line"
                                    clearable
                                />
                            </v-expand-transition>

                            
                            <v-expand-transition> 
                                <v-slider
                                    v-if="Boolean(lease.buyout)"
                                    v-model="lease.spiff"
                                    :min="0"
                                    :max="0.05"
                                    :step="0.01"
                                    thumb-label="always"
                                    thumb-color="deep-purple darken-4"
                                    prepend-icon="mdi-sale"
                                    :messages="['Prime incitative']"
                                    class="mt-5"
                                >
                                    <template v-slot:thumb-label="item">
                                        <span>{{parseInt(item.value * 100)}}%</span>
                                    </template>
                                </v-slider>
                            </v-expand-transition>

                            <v-expand-transition>
                                <div v-if="!trx.lease">
                                    <v-alert type="warning">Achat au comptant</v-alert>
                                </div>
                            </v-expand-transition>                        
                        </v-card-text>
                    </v-card>
                </v-stepper-content>

                <v-stepper-step 
                    :complete="step > 7" 
                    step="7"
                    color="deep-purple darken-4"
                    :class="Boolean(trx.mainframe.length) ? 'clickable' : ''"
                    @click.prevent="doStep(7, Boolean(trx.mainframe.length))"
                >Déterminer les termes du contrat de service (coût-par-page)</v-stepper-step>

                <v-stepper-content step="7">
                    <v-card v-if="Boolean(trx.mainframe.length)">
                        <v-alert 
                            v-if="!(Boolean(cpp.length) && Boolean(cpp[1].cpp))" 
                            type="info"
                        >Aucun CPP déterminé pour le {{ mainframe.model }} de {{ getVendorsNameById(mainframe.vendor) }}</v-alert>

                        <v-card-text v-else>
                            <div v-for="item in Object.entries(cpp[1].cpp)" :key="`radio-${item[0]}`">
                                <v-sheet 
                                    v-if="Boolean(item[1].filter(x => Boolean(x)).length)" 
                                    class="mt-5 pa-5"
                                    :color="cppTags.filter(x => x.name === item[0])[0].color" 
                                >
                                    <v-row>
                                        <v-col cols="1" class="d-flex align-center justify-center">
                                            <v-avatar color="white">
                                                <v-icon 
                                                    v-if="Boolean(cppTags.filter(x => x.name === item[0])[0].icon)" 
                                                    medium
                                                    light
                                                    :title="cppTags.filter(x => x.name === item[0])[0].title"
                                                >
                                                    {{ cppTags.filter(x => x.name === item[0])[0].icon }}
                                                </v-icon>
                                            </v-avatar>
                                        </v-col>

                                        <v-col>
                                            <v-row class="d-flex align-center">
                                                <v-col cols="6">
                                                    <v-slider
                                                        v-model="forecasts[item[0]].cpp"
                                                        :rules="cppRules(Math.min.apply(Math, item[1]), Math.max.apply(Math, item[1]))"
                                                        :min="Math.min.apply(Math, item[1])"
                                                        :max="Math.max.apply(Math, item[1]) * 1.25"
                                                        :step="0.001"
                                                        thumb-label="always"
                                                        thumb-color="deep-purple darken-4"
                                                        :messages="[`Contrat de service: ${forecasts[item[0]].cpp}`]"
                                                        dark
                                                    />
                                                </v-col>
                                                        
                                                <v-col cols="6">                                            
                                                    <v-text-field 
                                                        v-model="forecasts[item[0]].vol"
                                                        :disabled="!Boolean(forecasts[item[0]].cpp)"
                                                        dark
                                                        type="number"
                                                        step="5000"
                                                        append-outer-icon="mdi-plus" 
                                                        @click:append-outer="csVol(item[0])" 
                                                        prepend-icon="mdi-minus" 
                                                        @click:prepend="csVol(item[0], '-')"
                                                        :messages="['Volume annuel estimé']"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-sheet>

                                <v-sheet 
                                    v-if="!Boolean(item[0] === 'CMY' && mainframe.color === false) && !Boolean(item[1].filter(x => Boolean(x)).length)"
                                    :color="cppTags.filter(tag => tag.name === item[0])[0].color" 
                                    class="d-flex align-center mt-5 pa-5"
                                    dark
                                >
                                    Aucun niveau de prix n'a encore été déterminé pour cet appareil...
                                    <v-spacer />
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                fab
                                                small
                                                color="red"
                                                dark
                                                v-on="on"
                                                @click.stop="$emit('prompt', `No CPP found for document ${mainframe} ${item[0]}`)"
                                            >
                                                <v-icon dark>mdi-alert</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Signaler</span>
                                    </v-tooltip>
                                </v-sheet>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-stepper-content>            
                    
                <v-stepper-step 
                    :complete="step > 8" 
                    step="8"
                    color="deep-purple darken-4"
                    :class="Boolean(trx.mainframe.length) ? 'clickable' : ''"
                    @click.prevent="doStep(8, Boolean(trx.mainframe.length))"
                >Visualiser les données calculées</v-stepper-step>

                <v-stepper-content step="8">
                    <v-card v-if="trx.mainframe.length" flat>
                        <v-card-text>
                            <v-row>
                                <v-col cols="8" class="align-self-center">
                                    <strong>{{ getVendorsNameById(mainframe.vendor) }} {{ mainframe.model.toUpperCase() }}</strong>
                                </v-col>
                                <v-col cols="4" class="text-right align-self-center">{{ mainframe.cost }}</v-col>
                            </v-row>
                            
                            <v-row v-for="acc in trx.accessories" :key="acc.id">
                                <v-col cols="8">
                                    <v-icon
                                        color="red"
                                        class="clickable"
                                        @click.stop="removeAccessoryFromCalc(acc)"
                                        left
                                        small
                                    >mdi-close</v-icon>

                                    <strong>{{Boolean(acc.model) ? acc.model : `${acc.description.substring(0, 12)}...` }}</strong>
                                </v-col>

                                <v-col cols="4" class="text-right align-self-center">
                                    {{acc.cost}}
                                </v-col>
                            </v-row>

                            <div v-if="Boolean(trx.promo.length)">
                                <v-divider class="my-5" />

                                <v-row>
                                    <v-col cols="8" class="d-flex align-center">
                                        <span class="mr-5">Escomptes appliquée:</span>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                >{{ trx.promo[0].name }}</v-btn>
                                            </template>

                                            <div class="d-flex flex-column">
                                                <span v-for="d in Object.entries(discounts).map(x => x[1])" :key="`discount-${d.model}`">{{d.model}}: -{{$p9.parse.money(d.value)}}</span>
                                            </div>
                                        </v-tooltip>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="4" class="text-right">-{{ $p9.parse.money(totalDiscount)}}</v-col>
                                </v-row>
                            </div>

                            <v-divider class="my-5" />

                            <div v-for="(item, index) in costs" :key="`amount-${index}`">
                                <v-row v-if="!Boolean(item.divider)">
                                    <v-col :style="Boolean(item.strong) ? 'font-weight: bold;' : ''">{{ item.title }}</v-col>
                                    <v-spacer></v-spacer>
                                    <v-col class="text-right" :style="Boolean(item.strong) ? 'font-weight: bold;' : ''">{{ item.amount }}</v-col>
                                </v-row>

                                <v-divider v-else class="my-5" />
                            </div>

                            <v-divider class="my-5" />

                            <v-row>
                                <v-col cols="8" class="align-self-center">Marge brute:</v-col>

                                <v-col cols="4" class="text-right align-self-center">
                                    {{ $p9.parse.money(getCalcMarkup()) }}
                                </v-col>

                                <v-col cols="6">
                                    <v-slider
                                        v-model="trx.markup"
                                        :min="0.05"
                                        :max="0.99"
                                        :step="0.01"
                                        thumb-label="always"
                                        thumb-color="deep-purple darken-4"
                                    >
                                        <template v-slot:thumb-label="item">
                                            <span>{{parseInt(item.value* 100)}}%</span>
                                        </template>
                                    </v-slider>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col><strong>Prix vendant:</strong></v-col>
                                <v-spacer></v-spacer>
                                <v-col class="text-right"><strong>{{ $p9.parse.money(totalCost + getCalcMarkup()) }}</strong></v-col>
                            </v-row>
                            
                            <v-row v-if="Boolean(leaseRate)">
                                <v-col>Mensualité:</v-col>
                                <v-spacer></v-spacer>
                                <v-col class="text-right">{{$p9.parse.money(leaseMonthlyPmt)}} /mois</v-col>
                                <v-col v-if="Boolean(leaseInterests)" cols="12" class="text-right">
                                    <span small>Taux d'intérêt annuel effectif: {{ leaseInterests }} %</span>
                                </v-col>
                            </v-row>

                            <v-expand-transition>
                                <div v-show="Boolean(getRecurrentSales())">
                                    <v-divider class="my-5" />

                                    <v-row>
                                        <v-col>Revenus CS:</v-col>
                                        <v-spacer></v-spacer>
                                        <v-col class="text-right">{{ $p9.parse.money(getRecurrentSales()) }} /an</v-col>
                                    </v-row>

                                    <v-sheet color="deep-purple darken-4">
                                        <v-sparkline
                                            :value="getForecasts(5)"
                                            height="100"
                                            padding="20"
                                            color="white"
                                            stroke-linecap="square"
                                            label-size="5"
                                            smooth
                                        >
                                            <template 
                                                v-slot:label="item"
                                                color="white"
                                            >
                                                {{ $p9.parse.money(item.value) }}
                                            </template>
                                        </v-sparkline>
                                    </v-sheet>
                                </div>
                            </v-expand-transition>
                            
                            <div v-if="Boolean(lease.vendor)">
                                <v-divider class="my-5" />
                            </div>

                        </v-card-text>
                    </v-card>
                </v-stepper-content>
            </v-stepper>
        </v-card>
    </v-card>
</template>

<script>
export default {
    name: 'Calculator',
    props: [
        'document',
        'collection',
        'updatedCalc'
    ],
    data: () => ({
        dialog: false,
        dial: false,
        step: 1,
        defaultSort: ['vendor', 'model'],
        search: {
            show: false,
            tools: ['text', 'vendor'],
            vendor: null,
            text: null,
            color: null,
            category: null,
        },
        trx: {
            uid: null,
            mainframe: [],
            accessories: [],
            promo: [],
            installation: 125,
            transport: 80,
            markup: 0.4,
            lease: false,
            buyout: false,
            repo: false,
            customPromo: false,
        },
        customPromo: {
            date: new Date().toISOString().split('T')[0],
            authorizedBy: null,
            details: null,
            discount: 0,
        },
        repo: {
            value: 0,
            desc: null,
        },
        buyout: {
            value: 0,
            vendor: null,
            leaseId: null,
        },
        lease: {
            vendor: null,
            freq: null,
            term: null,
            rate: null,
            buyout: null,
            spiff: null,
        },
        forecasts: {
            K: {
                cpp: null,
                vol: null,
                sales: null,
            },
            CMY: {
                cpp: null,
                vol: null,
                sales: null,
            },
            SCN: {
                cpp: null,
                vol: null,
                sales: null,
            },
        },
    }),
    computed: {
        opportunity() {
            return this.$store.state[this.collection].items[this.document]
        },
        costs() {
            return [
                {
                    title: `Frais d'installation`,
                    name: `installFee`,
                    amount: this.$p9.parse.money(this.trx.installation)
                },
                {
                    title: `Frais de transport`,
                    name: `transportFee`,
                    amount: this.$p9.parse.money(this.trx.transport)
                },
                {
                    divider: true
                },
                {
                    title: `Rachat d'équipement`,
                    name: `repoValue`,
                    amount: this.$p9.parse.money(this.repo.value)
                },
                {
                    title: `Résiduel sur financement courant`,
                    name: `trxBuyoutValue`,
                    amount: this.$p9.parse.money(this.buyout.value)
                },
                {
                    divider: true
                },
                {
                    title: `Coûtant total`,
                    name: `totalCost`,
                    strong: true,
                    amount: this.$p9.parse.money(this.totalCost)
                }
            ]
        },
        items() {
            return Object.entries(this.$store.state.items.items)
        },
        leasing() {
            return Object.entries(this.$store.state.leasing.items)
        },
        categories() {            
            return Object.entries(this.$store.state.items.categories).map(x => x[1])
        },
        mainframes() {
            return this.items ? this.items.filter(item => this.isMainframe(item)): []
        },
        visibleMainframes() {
            if(Boolean(this.mainframes.length)) {
                let items = this.mainframes
                
                if(Boolean(this.search.vendor)) {
                    items = items.filter(item => item[1].vendor === this.search.vendor)
                }
                
                if(Boolean(this.search.category)) {
                    let category = Object.entries(this.$store.state.items.categories).filter(x => x[1].value === this.search.category)
                    if(Boolean(category.length)) {
                        category = category[0][1].value
                        items = items.filter(item => item[1].categories.indexOf(category) > -1)
                    }
                }

                if(this.search.color !== null) {
                    items = Boolean(this.search.color) ? items.filter(item => Boolean(item[1].color)) : items.filter(item => !Boolean(item[1].color))
                }

                let mainframes = []
                
                this.mainframes.forEach(mf => {
                    let mainframe = mf[1]
                    mainframe.id = mf[0]
                    mainframes.push(mainframe)
                })

                return mainframes
            }
            else return []
        },
        mainframe() {
            return Boolean(this.trx.mainframe.length === 1) ? this.trx.mainframe[0] : null
        },
        accessories() {
            let accessories = []

            if(Boolean(this.trx.mainframe.length)) {
                this.items.filter(item =>  
                    !this.isMainframe(item) && 
                    item[1].baseModel.indexOf(this.mainframe.model) > -1
                )
                .forEach(acc => {
                    let accessory = acc[1]
                    accessory.id = acc[0]
                    if(!Boolean(this.trx.accessories.filter(x => x.id === acc[0]).length)) accessories.push(accessory)
                })
            }
            
            return accessories
        },
        vendors() {
            return Object.entries(this.$store.state.vendors.items)
        },
        vendor() {                
            return Boolean(this.mainframe) ? this.getVendorById(this.mainframe.vendor) : null
        },
        vendorsSelect() {
            let vendors = []

            switch(this.step) {
                case 6:
                    vendors = this.vendors.filter(vendor => vendor[1].categories.indexOf('LEASE') > -1)
                    break

                default:
                    vendors = this.vendors.filter(vendor => vendor[1].categories.indexOf('LEASE') === -1)
            }
            
            return vendors.map(vendor => {
                return {
                    value: vendor[0],
                    text: this.getVendorsNameById(vendor[0]),
                }
            })
        },
        leaseVendor() {
            return Boolean(this.lease.vendor) ? this.leasing.filter(x => x[1].vendor === this.lease.vendor)[0] : []
        },
        leaseVendorOptions() {
            return Boolean(this.leaseVendor) ? this.leaseVendor[1].chart
                .filter(y => Number(y.min) < Number(this.totalCost) && Number(y.max) > Number(this.totalCost))[0].terms : []
        },
        leaseOptionTerms() {
            return Boolean(this.lease.vendor) ? 
                Object.keys(_.countBy(this.leaseVendorOptions.map(x => x.term))).map((x) => Number(x)) : []
        },
        leaseTermFrequencies() {
            let options = []
            let values = Boolean(this.lease.term) ? 
                Object.keys(_.countBy(this.leaseVendorOptions.filter(x => x.term === this.lease.term)
                .map(x => x.frequency))) : []
            
            values.forEach(v => {
                options.push({
                    text: v === "Q" ? "Trimestrielle" : v === "M" ? "Mensuelle" : "Annuelle",
                    value: v
                })
            })

            return options
        },
        leaseFrequencyBuyouts() {
            return Boolean(this.lease.freq) ? 
                Object.keys(_.countBy(this.leaseVendorOptions
                    .filter(x => x.term === this.lease.term && x.frequency === this.lease.freq)
                    .map(x => x.buyout))) : []
        },
        leaseRate() {
            let rate = Boolean(this.leaseFrequencyBuyouts.length) ? 
                Number(
                    Object.keys(
                        _.countBy(
                            this.leaseVendorOptions.filter(x => 
                                x.term === this.lease.term && 
                                x.frequency === this.lease.freq &&
                                x.buyout === this.lease.buyout)
                            .map(x => x.factor)
                        )
                    )[0]) : null
            return !isNaN(rate) ? rate * (Number(this.lease.spiff) + 1) : null
        },
        leaseMonthlyPmt() {
            return Boolean(this.leaseRate) ? 
                (this.leaseRate / 1000) * 
                (this.totalCost + this.getCalcMarkup()) / 
                (this.lease.freq === "Q" ? 3 : this.lease.freq === "M" ? 1 : 12) : null
        },
        leaseInterests() {
            return null
        },
        cppTags() {
            return this.$store.state.cpp.ref.tags
        },
        cpp() {
            if(Boolean(this.trx.mainframe.length)) {
                let cpp = Object.entries(this.$store.state.cpp.items).filter(doc => 
                    doc[1].mainframe.id === this.mainframe.id || 
                    doc[1].mainframe.model === this.mainframe.model || 
                    doc[0] === this.mainframe.cpp
                )
                
                return Boolean(cpp.length) ? cpp[0] : []
            }
            else return []
        },
        promos() {
            if(Boolean(this.trx.mainframe.length)) {
                let promos = []

                Object.entries(this.$store.state.promos.items).filter(p => Object.keys(p[1].items).indexOf(this.mainframe.id) > -1).forEach(promo => {
                    let prom = promo[1]
                    prom.id = promo[0]
                    
                    promos.push(prom)
                    if(!Boolean(this.trx.promo.length) && prom.code === 'BASEDISCOUNT') {
                        this.trx.promo.push(prom)
                    }
                })

                return promos
            }
            else return []
        },
        allowCustomPromo() {
            return Boolean(this.customPromo.details) &&
                Boolean(this.customPromo.authorizedBy) &&
                Boolean(this.customPromo.discount)
        },
        totalDiscount() {
            return this.$p9.arrays.listSum(Object.entries(this.discounts).map(x => x[1]), 'value')
        },
        discounts() {
            let discount = 0
            let discounts = []

            if(Boolean(this.mainframe) && this.trx.promo.length === 1) {
                //Itération à travers de tous les items couverts par la promotion sélectionnée
                Object.entries(this.trx.promo[0].items).forEach(item => {
                    let id = item[0]
                    let data = item[1]

                    //Escompte appliquable sur le mainframe...
                    if(Boolean(id === this.mainframe.id)) {
                        //Rabais sur mainframe
                        if(Boolean(data.rebate)) {
                            //Conversion des escomptes "pourcentage" en escompte "montant"
                            let rebate = Number(data.rebate) > 1 ? 
                                Number(data.rebate) :
                                Number(this.$p9.parse.float(this.mainframe.cost)) * Number(data.rebate)
                            
                            discounts[this.mainframe.id] = {
                                discount: data.price,
                                value: rebate,
                                model: this.mainframe.model,
                            }
                        }

                        //Niveaux de prix alternatif sur mainframe
                        else if(Boolean(data.price)) {
                            //Conversion d'un prix escompté en rabais
                            let rebate = Number(this.$p9.parse.float(this.mainframe.cost)) - Number(data.price)
                            
                            discounts[this.mainframe.id] = {
                                discount: data.price,
                                value: rebate,
                                model: this.mainframe.model,
                            }
                        }                        
                            
                        //Escomptes sur accessoires appliquées à partir du mainframe
                        if(Boolean(data.accessories)) {
                            this.trx.accessories.forEach(acc => {
                                //Conversion des escomptes "pourcentage" en escompte "montant"
                                let rebate = Number(data.accessories) > 1 ? 
                                    Number(data.accessories) :
                                    Number(this.$p9.parse.float(acc.cost)) * Number(data.accessories)

                                //Éviter d'écraser toute promo définie au niveau de accessoire 
                                /* (les promos définies au niveau de l'accessoire ont préséance, 
                                ainsi, il est possible d'accorder de manière générale une escompte 
                                sur les accessoires tout en permettant des exceptions) */
                                if(!Boolean(discounts[acc.id])) {
                                    discounts[acc.id] = {
                                        discount: data.rebate,
                                        value: rebate,
                                        model: acc.model,
                                    }
                                }
                            })
                        }
                    }

                    //Si l'item analysé concerne un accessoire présent sur la soumission...
                    if(Boolean(this.trx.accessories.filter(acc => acc.id === id).length)) {
                        let accessory = this.trx.accessories.filter(acc => acc.id === id)
                        if(accessory.length === 1) {
                            accessory = accessory[0]

                            //Escomptes sur l'accessoire
                            if(typeof data.rebate === 'number') {
                                //Conversion des escomptes "pourcentage" en escompte "montant"
                                let rebate = Number(data.rebate) > 1 ? 
                                    Number(data.rebate) :
                                    Number(this.$p9.parse.float(accessory.cost)) * Number(data.rebate)
                              
                                discounts[accessory.id] = {
                                    discount: data.rebate,
                                    value: rebate,
                                    model: accessory.model,
                                }
                            }

                            //Conversion des "niveaux de prix" en escompte "montant"
                            else if(Boolean(data.price)) {
                                let rebate = Number(this.$p9.parse.float(accessory.cost)) - Number(data.price)
                                
                                discounts[accessory.id] = {
                                    discount: data.rebate,
                                    value: rebate,
                                    model: accessory.model,
                                }
                            } 
                        }                        
                    }
                    
                    else {
                        //console.log(`No match for ${id} (${data.model}, ${data.sku})`)
                    }
                })
            }

            return discounts
        },
        totalCost() {
            let mainframeCost = Boolean(this.mainframe) ? Number(this.$p9.parse.float(this.mainframe.cost)) : 0
            let accessoriesCost = Boolean(this.trx.accessories.length) ? this.$p9.arrays.listSum(this.trx.accessories, 'cost') : 0            
            let totalDiscount = Boolean(this.totalDiscount) ? Number(parseFloat(this.totalDiscount).toFixed(2)) : 0
            let cost = mainframeCost + accessoriesCost - totalDiscount
            let prepAndShip = Number(this.trx.installation) + Number(this.trx.transport)
            let repoAndBuyout = Number(this.repo.value) + Number(this.buyout.value)
            
            return cost + prepAndShip + repoAndBuyout
        },
    },
    methods: {
        prompt(msg) {
            console.log(msg)
        },
        save() {
            if(!Boolean(this.opportunity.calcs)) this.opportunity.calcs = {}
            let accessories = []

            let calc = {
                author: this.$store.state.auth.user.id,
                trx: this.trx,
                repo: this.repo,
                buyout: this.buyout,
                lease: this.lease,
                forecasts: this.forecasts,
                lastUpdate: {
                    time: new Date().toISOString(),
                    user: this.$store.state.auth.user.id,
                    action: 'created',
                },
                context: {
                    totalDiscount: this.totalDiscount,
                    totalCost: this.totalCost,
                }
            }

            calc.trx.mainframe = calc.trx.mainframe[0].id

            calc.trx.accessories.forEach(acc => {
                accessories.push(acc.id)
            })

            calc.trx.accessories = accessories

            this.opportunity.calcs[this.trx.uid] = calc

            this.$store.dispatch(`${this.collection}/set`, [this.document, this.opportunity])
            
            this.initCalc()
            this.close()
        },
        loadCalc() {
            if(Boolean(this.updatedCalc)) {
                let calc = this.opportunity.calcs[this.updatedCalc]

                let mainframe = this.items.filter(x => x[0] === calc.trx.mainframe)
                mainframe = !Boolean(mainframe.length) ? {} : {id: mainframe[0][0], ...mainframe[0][1]}


                let accessories = []                
                calc.trx.accessories.forEach(acc => {
                    let accessory = this.items.filter(y => y[0] === acc)
                    if(Boolean(accessory.length)) accessories.push({ id: accessory[0][0], ...accessory[0][1] })
                })
                
                this.trx = calc.trx
                this.currentLease = calc.currentLease
                this.forecasts = calc.forecasts,
                this.trx.mainframe = [mainframe]
                this.trx.accessories = accessories
                this.repo = calc.repo
                this.buyout = calc.buyout
                this.lease = calc.lease
                this.forecasts = calc.forecasts
                if(Boolean(calc.discount)) this.discounts.push(calc.discount) //!!!
                this.step = 8
            }
        },
        addCustomPromo() {
            let promo = {
                code: 'oneTimer',
                name: `Escompte spéciale autorisée par ${this.customPromo.authorizedBy}`,
                comments: this.customPromo.details,
                effectiveDate: this.customPromo.date,
                expiryDate: this.customPromo.date + 30,
                vendor: this.vendor,
                items: {}
            }

            promo.items[this.mainframe.id] = {
                rebate: this.$p9.parse.float(this.customPromo.discount),
                status: 1,
                model: this.mainframe.model,
                sku: this.mainframe.sku,
            }

            this.trx.promo = [promo]
        },
        searchColor(value) {
            switch(this.search.color) {
                case null:
                    this.search.color = value
                    break
                    
                case true:
                    this.search.color = value === true ? null : false
                    break
                    
                case false:
                    this.search.color = value === false ? null : true
                    break
            }
        },
        cppRules(min, max) {
            return [
                v => v >= min || 'Le CPP actuel est sous le niveau agressif authorisé...',
                v => v <= max || 'Le CPP actuel est supérieur au nieau profitable...',
            ]
        },
        isMainframe(item) {
            if(Array.isArray(item)) item = item[1]
            
            return item.categories.indexOf('MFP') > -1 || 
                item.categories.indexOf('PROD') > -1 || 
                item.categories.indexOf('PRN') > -1
        },
        getVendorById(id) {  
            let vendor = this.vendors.filter( vendor => vendor[0] === id )              
            return Boolean(vendor) ? vendor[0] : null
        },
        getVendorsNameById(id) {                
            return Boolean(this.getVendorById(id)) ? this.getVendorById(id)[1].name : null
        },
        addMainframeToCalc(e) {
            this.trx.mainframe = [e]
            this.addMainframeToCalc()
        },
        addAccessoryToCalc(e) {
            this.trx.accessories.push(e)
        },
        applyPromoToCalc(e) {
            this.trx.promo = []
            this.trx.promo.push(e)
        },
        removeAccessoryFromCalc(acc) {
            this.trx.accessories = this.trx.accessories.filter(x => x !== acc)
        },
        getCalcMarkup() {
            return (this.totalCost / (1 - this.trx.markup)) - this.totalCost
        },
        getRecurrentSales() {
            let sum = 0
            Object.keys(this.forecasts).forEach(x => {
                sum += Boolean(this.forecasts[x]) ? this.forecasts[x].sales : 0
            })

            return sum
        },
        getForecasts(years) {
            let arr = []

            if(Boolean(this.getRecurrentSales())) {
                for(let i = 0; i <= years; i++) arr.push(this.getRecurrentSales() * i)
            }

            return arr
        },
        updateCPP(item, value) {
            this.forecasts[item].cpp = Number(value)
        },
        headers(view) {
            let arr = []
            let headers = [
                'vendor',
                'model',
                'categories',
                'color',
                'sku',
                'cost',
                'comment',
            ]

            switch(view) {
                case 'items': 
                    headers.forEach(header => {
                        let target = this.$store.state.items.headers.filter(item => item.value === header)[0]
                        if(Boolean(target)) arr.push(target)
                    })                    
                    return arr
                    break

                case 'vendors':
                    return this.$store.state.vendors.headers.filter(header => header.value === 'vendor')
                    break

                case 'accessories':
                    headers = [
                        'model',
                        'description',
                        'sku',
                        'cost',
                    ]                    
                    return this.$store.state.items.headers.filter(h => headers.includes(h.value))
                    break

                case 'promos':
                    headers = [
                        'name',
                        'code',
                        'effectiveDate',
                        'expiryDate',
                    ]  
                    return this.$store.state.promos.headers.filter(h => headers.includes(h.value))
                    break

                default:
                    return this.$store.state.items.headers.filter(header => headers.includes(header.value))
            }
        },
        csVol(item, op = null) {
            let currentVol = Number(this.forecasts[item].vol)

            if(op === '-') {
                this.forecasts[item].vol = (currentVol - 500 > 0) ? currentVol - 5000 : 0
            }
            else { 
                this.forecasts[item].vol = currentVol + 5000
            }

            this.forecasts[item].sales = Number(this.forecasts[item].vol) * Number(this.forecasts[item].cpp)
        },
        doStep(step, condition = true) {
            this.step = Boolean(condition) ? step : this.step
            this.initSearchTool()
        },
        openCalc() {
            this.dial = false
        },
        initSearchTool() {
            this.search = {
                tools: ['text', 'vendor'],
                show: false,
                vendor: null,
                text: null,
                color: null,
                category: null,
            }
        },
        clearSearchTool() {
            this.dial = false
            this.initSearchTool()
        },
        initCustomPromo() {
            this.trx.promo = []            
            this.customPromo.date = new Date().toISOString().split('T')[0]
            this.customPromo.authorizedBy = null
            this.customPromo.details = null
            this.customPromo.discount = 0
        },
        clearPromos() {
            this.initCustomPromo()
            this.trx.customPromo = false
        },
        initCalc() {
            this.dial = false
            this.dialog = false
            this.step = 1

            this.trx = {
                uid: null,
                mainframe: [],
                accessories: [],
                promo: [],
                installation: 125,
                transport: 80,
                markup: 0.4,
                lease: false,
                buyout: false,
                repo: false,
            }

            this.repo = {
                value: 0,
                desc: null,
            }

            this.buyout = {
                value: 0,
                vendor: null,
                contractId: null,
            }

            this.lease = {
                vendor: null,
                freq: null,
                term: null,
                rate: null,
                buyout: null,
                spiff: null,
            }

            this.forecasts = {
                K: {
                    cpp: null,
                    vol: null,
                    sales: null,
                },
                CMY: {
                    cpp: null,
                    vol: null,
                    sales: null,
                },
                SCN: {
                    cpp: null,
                    vol: null,
                    sales: null,
                },
            }

            this.clearPromos()
            this.clearSearchTool()  
        },
        close() {   
            this.initCalc()
            this.$emit('close')   
        },
        init() {
            this.initCalc()
            this.initSearchTool()
            this.initCustomPromo()
        },
    },
    mounted() {
        this.init()
        this.trx.uid = Boolean(this.updatedCalc) ? this.updatedCalc : this.$p9.uid()

        if(Boolean(this.updatedCalc)) this.loadCalc()
    },
}
</script>

<style scoped>
.Calculator {
    overflow: hidden;
    max-width: 100vw;
}
</style>